import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSupportContent, useSupportSectionIntro } from '../../config/queries'
import NotFound from '../Error/NotFound'
import { isSupportSectionSlug } from './sections'
import SupportLayout from './SupportLayout'
import SupportArticleContent from './SupportArticleContent'
import SupportContentSkeleton from './SupportContentSkeleton'
import SupportFaqAccordion from './SupportFaqAccordion'
import { htmlExcerpt } from '../../helpers/seo'

const SupportSectionPage = () => {
  const { section: sectionParam } = useParams()
  const { t } = useTranslation()
  const { data, isPending } = useSupportContent()
  const validSection =
    sectionParam && isSupportSectionSlug(sectionParam)
      ? sectionParam
      : undefined
  const { data: intro, isPending: introPending } =
    useSupportSectionIntro(validSection)

  if (!validSection) return <NotFound />

  const section = validSection
  const articles = data?.articlesBySection[section] ?? []
  const sectionFaqs =
    data?.faqEntries.filter((entry) => entry.section === section) ?? []

  return (
    <SupportLayout
      section={section}
      articles={articles}
      articlesPending={isPending}
      title={t(`support.sections.${section}.title`)}
      description={htmlExcerpt(intro?.content) || t('support.hub-description')}
    >
      {isPending || introPending ? (
        <SupportContentSkeleton />
      ) : !intro ? (
        <>
          <p className='text-muted-foreground'>{t('support.no-intro')}</p>
          <SupportFaqAccordion entries={sectionFaqs} />
        </>
      ) : (
        <article className='flex flex-col gap-10'>
          <div>
            <SupportArticleContent content={intro.content} />
          </div>
          <SupportFaqAccordion entries={sectionFaqs} />
        </article>
      )}
    </SupportLayout>
  )
}

export default SupportSectionPage
